import * as types from "../types/orderManagement.types";
import moment from "moment";

const initialState = {
  taskNewData: [],
  taskNewPagination: [],
  ordersFilter: {
    storeIds: [],
    status: [],
    phone: "",
    rider: "",
    rider_id: "",
    order_id: "",
    packed_time_exist: [],
    currentPage: 1,
    limit: 10,
    startDate: moment(),
    endDate: moment(),
    sort: "desc",
  },
  ordersFilterStore: {
    storeIds: [],
    status: [],
    phone: "",
    rider: "",
    rider_id: "",
    order_id: "",
    packed_time_exist: [],
    currentPage: 1,
    limit: 10,
    startDate: moment(),
    endDate: moment(),
    sort: "desc",
  },
  searchClick: 1,
};

const OrderManagementNewReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ORDER_MANAGEMENT_TASK_NEW_DATA:
      return { ...state, taskNewData: action.payload };
    case types.SET_ORDER_MANAGEMENT_TASK_NEW_PAGINATION_DATA:
      return { ...state, taskNewPagination: action.payload };
    case types.SET_ORDER_FILTER:
      return { ...state, ordersFilter: action.payload };
    case types.SET_ORDER_FILTER_STORE:
      return { ...state, ordersFilterStore: action.payload };
    case types.SET_ORDER_FILTER_CLICK_SEARCH:
      return { ...state, searchClick: action.payload };
    case types.RESET_ORDER_MANAGEMENT_REDUCER:
      return {
        ...state,
        taskNewData: [],
        taskNewPagination: [],
      };
    default:
      return state;
  }
};
export default OrderManagementNewReducer;
